<template>
  <div class="mision">
    <!-- <router-link
      to="/progreso"
      class="miperfil abs pointer"
      data-aos="fade-right"
      data-aos-delay="200"
    >
      <img
        src="../../../assets/imgs/mision/btn-mi-perfil.png"
        alt="Encauce"
        class="img-fluid"
      />
    </router-link> -->

    <!-- <div class="contentabs">
      <div class="pregunta">
        <img
          src="../../../assets/imgs/mision/bg-pregunta-intermedia.png"
          alt="pregunta"
        />
        <div class="texto blanco">
          <div>
            <p>
              Estás a punto de iniciar una aventura en la que te conocerás más a
              fondo, lo que te permitirá desarrollar increíbles habilidades.
            </p>
            <p class="mb-0">En esta misión vamos a descubrir tu estilo de aprendizaje.</p>
          </div>
        </div>
      </div>
    </div> -->

    <section class="pantalla mision2_intro">
      <div class="cont-btn-sig btn-avanzar col-12">
        <button @click="avanzar" class="btn-sig">
          <span class="texto">
            <span class="bold">CONTINUAR</span>
          </span>
          <img
            class="icono"
            src="../../../assets/imgs/mision/cohete.png"
            alt="icono"
          />
          <span class="flecha">
            <img src="../../../assets/imgs/mision/flecha-sig3.png" alt="icono" />
          </span>
        </button>
        <div class="flecha2">
          <img src="../../../assets/imgs/mision/flecha-sig2.png" alt="icono" />
        </div>
        <div class="flecha1">
          <img src="../../../assets/imgs/mision/flecha-sig1.png" alt="icono" />
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";
import router from "../../../router/index";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      maya_outfit: -1,
      condicion: false,
      mision: 5,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  },
  methods: {
    avanzar() {
      this.$router.push("/mision-5-advertencia");
    },
  },
};
</script>


<style lang="scss" scoped>
.mision {
  .contentabs {
  }
}

.btn-avanzar {
  position: absolute;
  bottom: 12%;
  left: 6%;
}

.mision2_intro {
  background: url(../../../assets/imgs/mision/5_intro/still.jpg) no-repeat;
  background-size: contain;
  background-position: center center;
}
</style>
